import {useIntl} from "react-intl";

export interface IComponent {
  fieldsProps: any;
  i18n: string;
  value?: boolean;
  disabled?: boolean;
  inputGroup?: any[];
  label?: string;
}

export default function (props: IComponent) {
  const intl = useIntl()

  return <>
    <div className={'d-flex align-items-center justify-content-between h-100'}>
      {props.label && <label className='fw-bold fs-6 mb-0'>{props.label}</label>}
      <div className='form-check form-switch mb-0'>
        <input
          placeholder={intl.formatMessage({id: props.i18n})}
          type={'checkbox'}
          role={'switch'}
          {...props.fieldsProps}
          checked={props.value}
          disabled={props.disabled}
          className={'form-check-input mt-0'}
        />
      </div>
    </div>
  </>
}
